export default function initForms() {
    let isSubmitting = false;
    const formElements = document.querySelectorAll("form[data-ajax]");
    const inputClassList = ["border-red-300", "is-invalid"];
    const errorClassList = ["help-block", "form-text"];

    function pushDatalayer(
        eventLabel,
        eventStatus,
        formIdentifier,
        customPayload = "{}"
    ) {
        let payload;
        try {
            payload = JSON.parse(customPayload);
        } catch (e) {
            console.error("Could not parse customPayload", e);
            payload = {};
        }
        if (window.dataLayer) {
            if (eventStatus === "success") {
                dataLayer.push({
                    event: `form-${formIdentifier}`,
                    eventLabel,
                    eventStatus,
                    formIdentifier,
                    ...payload,
                });
                dataLayer.push({
                    event: "form",
                    eventLabel,
                    eventStatus,
                    formIdentifier,
                    ...payload,
                });
            } else {
                dataLayer.push({
                    event: `form-error-${formIdentifier}`,
                    eventLabel,
                    eventStatus,
                    formIdentifier,
                    ...payload,
                });
                dataLayer.push({
                    event: "form-error",
                    eventLabel,
                    eventStatus,
                    formIdentifier,
                    ...payload,
                });
            }
        }
    }

    function hideMessages(formElement) {
        const successNotice = formElement.querySelector("[data-success]");
        if (successNotice) {
            successNotice.classList.add("hidden");
        }
        const errorNotice = formElement.querySelector("[data-error]");
        if (errorNotice) {
            errorNotice.classList.add("hidden");
        }
    }

    function scrollTo(noticeElement) {
        const offset = 20;
        const headerSticky = document.querySelector("header.sticky");
        const noticeElementPosition = noticeElement.getBoundingClientRect().top;
        const currentPosition = window.pageYOffset;
        const headerHeight = headerSticky.getBoundingClientRect().height ?? 0;

        window.scrollTo({
            top:
                noticeElementPosition +
                currentPosition -
                (headerHeight + offset),
            behavior: "smooth",
        });
    }

    function showSuccessMessage(formElement, successMessage) {
        const successNotice = formElement.querySelector("[data-success]");
        const formContent = formElement.querySelector("[data-form-content]");

        if (successMessage) {
            successNotice.innerHTML = successMessage;
        }

        successNotice.classList.remove("hidden");
        formContent.classList.add("hidden");

        scrollTo(successNotice);
    }

    function showErrorMessage(formElement) {
        const errorNotice = formElement.querySelector("[data-error]");
        errorNotice.classList.remove("hidden");
        scrollTo(errorNotice);
    }

    function addValidationErrors(formElement, key, value) {
        if (key.includes(".")) {
            // Split string on dot and make it an array
            const keyArray = key.split(".");

            // Get the last and first item in the array
            const firstKey = keyArray[0];
            const lastKey = keyArray[1];

            key = firstKey + "[" + lastKey + "]";
        }

        let inputElem = formElement.querySelector(
            `[name="${key}"], [name="${key}[]"]`
        );

        const errorForAttribute = formElement.querySelector(`[data-error-for="${key}"]`);
        if (errorForAttribute) {
            inputElem = errorForAttribute;
        }

        if (inputElem) {
            inputElem.classList.add(...inputClassList);

            const errorElem = document.createElement("span");
            errorElem.classList.add(...errorClassList);
            errorElem.textContent = value;

            inputElem.parentElement.appendChild(errorElem);
        }
    }

    function removeValidationErrors(formElement) {
        const invalidInputElems = formElement.querySelectorAll(`.is-invalid`);
        invalidInputElems.forEach((invalidInputElem) => {
            invalidInputElem.classList.remove(...inputClassList);
        });

        const invalidErrorElems = formElement.querySelectorAll(`.help-block`);
        invalidErrorElems.forEach((invalidErrorElem) => {
            invalidErrorElem.remove();
        });
    }

    function toggleDisabledState(element, disabled) {
        if (disabled) {
            element.setAttribute("disabled", true);
            element.setAttribute("aria-disabled", true);
        } else {
            element.removeAttribute("disabled");
            element.removeAttribute("aria-disabled");
        }
    }

    function sendFormData(formElement) {
        if (isSubmitting) {
            return;
        }
        isSubmitting = true;
        toggleDisabledState(
            formElement.querySelector('button[type="submit"]'),
            true
        );

        const Request = new XMLHttpRequest();

        Request.open(formElement.method, formElement.action);
        // Needed to accept response json for validation
        Request.setRequestHeader("Accept", "application/json");

        Request.onreadystatechange = function (e) {
            if (this.readyState === XMLHttpRequest.DONE) {
                isSubmitting = false;
                toggleDisabledState(
                    formElement.querySelector('button[type="submit"]'),
                    false
                );
                removeValidationErrors(formElement);
                hideMessages(formElement);
                const eventLabel = JSON.stringify([
                    location.href,
                    `form-${formElement.id}`,
                    formElement.action,
                ]);
                const formIdentifier = formElement.dataset.identifier;
                const customPayloadAttr =
                    formElement.getAttribute("data-gtag-event");
                let customPayload = customPayloadAttr;

                const formData = new FormData(formElement);
                if (formData.get('starting') !== null) {
                    try {
                        customPayload = JSON.parse(customPayloadAttr);
                        customPayload['starting'] = formData.get('starting');
                        customPayload = JSON.stringify(customPayload);
                    }
                    catch (e) {
                        console.error('Could not parse custom payload');
                    }
                }
                if (
                    this.status === 0 ||
                    (this.status > 200 && this.status < 400)
                ) {
                    // Success.
                    location.hash = "#bedankt";
                    pushDatalayer(
                        eventLabel,
                        "success",
                        formIdentifier,
                        customPayload
                    );

                    // Check if the respons is json and it contains success message.
                    let successMessage;
                    try {
                        const json = JSON.parse(Request.responseText);
                        successMessage = json.success_message || undefined;
                    } catch {
                        // Ignore any exceptions.
                    }

                    showSuccessMessage(formElement, successMessage);
                } else if (
                    this.status === 200 &&
                    JSON.parse(Request.response).redirect
                ) {
                    window.location = JSON.parse(Request.response).redirect;

                    return;
                } else if (this.status === 422) {
                    // Validation errors.
                    const errors = JSON.parse(Request.response).errors;

                    pushDatalayer(
                        eventLabel,
                        "error",
                        formIdentifier,
                        customPayload
                    );
                    Object.keys(errors).forEach((error) => {
                        addValidationErrors(
                            formElement,
                            error,
                            errors[error][0]
                        );
                    });

                    const firstErrorElement = formElement.querySelector(
                        "." + errorClassList.join(".")
                    );
                    if (firstErrorElement) {
                        scrollTo(firstErrorElement);
                    }
                } else {
                    // Something huge is going wrong.
                    pushDatalayer(
                        eventLabel,
                        "error",
                        formIdentifier,
                        customPayload
                    );
                    showErrorMessage(formElement);
                    scrollTo(formElement);
                }
            }
        };

        Request.send(new FormData(formElement));
    }

    formElements.forEach((formElement) => {
        formElement.addEventListener(
            "submit",
            (e) => {
                e.stopPropagation();
                e.preventDefault();
                sendFormData(formElement);
            },
            false
        );
    });

    const searchFormElement = document.querySelector("form[data-ajax-search]");
    if (searchFormElement) {
        searchFormElement.addEventListener("submit", (e) => {
            // Prevent empty searches.
            const formDAta = new FormData(searchFormElement);
            if (formDAta.get("keyword") === "") {
                e.stopPropagation();
                e.preventDefault();
            }
        });
    }
}
